<template>
  <rest-page :fetch-endpoint="fetchEndpoint">
    <div class="campaigns-configuration-ct">
      <rest-form
        v-if="model"
        :save-endpoint="{}"
        :model="model"
        @on-error="isLoading = false"
      >
        <form-section
          :title="$t('Gamification_GameCampaignsConfiguration_JWTAuthSecret')"
          v-loading="isLoading"
        >
          <rest-form-item prop="jwt_auth_secret" class="default-width">
            <div style="display: flex; gap: 10px;">
              <el-input
                v-model="model.value"
                v-loading="isRegeneratingJwt"
                data-qa="configuration-generate-jwt"
              >
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-refresh"
                  style="font-size: 20px; cursor: pointer;"
                  @click="generateJwt()"
                ></i>
              </el-input>
              <el-button
                type="primary"
                @click="saveJwt"
                data-qa="configuration-save"
              >
                {{ $t('Button_Save') }}
              </el-button>
            </div>
          </rest-form-item>
        </form-section>
      </rest-form>
    </div>
  </rest-page>
</template>

<script>
import RestForm from '@/common/components/rest/RestForm.vue'
import RestFormItem from '@/common/components/rest/RestFormItem.vue'
import FormSection from '@/common/components/form/FormSection.vue'
import RestPage from '@/common/components/rest/RestPage.vue'
import { projectEndpoint } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'

export default {
  name: 'GameCampaignsConfiguration',
  components: { FormSection, RestFormItem, RestForm, RestPage },
  data() {
    return {
      isLoading: false,
      isRegeneratingJwt: false,
      model: {
        id: null,
        name: 'jwt_auth_secret',
        value: ''
      }
    }
  },
  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `gamify/${this.$route.params.id}/settings`,
        handler: data => {
          this.model = { ...this.model, ...(data.data[0] || {}) }
        }
      })
    }
  },
  methods: {
    generateJwt() {
      this.isRegeneratingJwt = true
      RestApi(
        projectEndpoint({
          method: 'get',
          url: `gamify/${this.$route.params.id}/settings/generate-jwt`
        })
      )
        .then(({ data }) => {
          this.model.value = data
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.isRegeneratingJwt = false
        })
    },
    saveJwt() {
      this.isLoading = true
      if (!this.model.id) {
        RestApi(
          projectEndpoint({
            method: 'post',
            url: `gamify/${this.$route.params.id}/settings`,
            data: {
              name: 'jwt_auth_secret',
              value: this.model.value
            }
          })
        )
          .then(() => {
            this.$message({
              message: this.$t('RestForm_SaveSuccessMessage'),
              type: 'success'
            })
          })
          .catch(error => {
            this.$message({
              message: error.message,
              type: 'error'
            })
          })
          .finally(() => {
            this.isLoading = false
          })
        return
      }
      RestApi(
        projectEndpoint({
          method: 'put',
          url: `gamify/${this.$route.params.id}/settings/${this.model.id}`,
          data: {
            name: 'jwt_auth_secret',
            value: this.model.value
          }
        })
      )
        .then(() => {
          this.$message({
            message: this.$t('RestForm_SaveSuccessMessage'),
            type: 'success'
          })
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.default-width {
  width: 596px;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-campaigns/GameCampaignsConfiguration.vue